import React, { FC, PropsWithChildren } from 'react';

import { ConsultationQueue } from '../Sidebar/presets/ConsultaionQueue';
import Header from './components/Header';
import Navigation from './components/Navigation';

import classes from './styles.module.scss';

interface IBaseLayout {
  hasQueue: boolean;
  notClosable: boolean;
}
export const BaseLayout: FC<PropsWithChildren<IBaseLayout>> = ({
  children,
  hasQueue,
  notClosable
}) => (
  <div className={classes.layout}>
    <a
      className={classes.topBar}
      href={`${
        process.env.REACT_APP_COMMAND_CENTER_URL
      }?accessToken=${localStorage.getItem('access_token')}`}
      target="_blank"
      rel="noopener noreferrer"
    >
      Check out the new Command Center (Beta) &rarr;
    </a>
    <div className={classes.header}>
      <Header />
      <Navigation />
    </div>
    <main className={classes.layout__children}>
      {children}
      {hasQueue && <ConsultationQueue notClosable={notClosable} />}
    </main>
  </div>
);
